module.exports = __webpack_public_path__ + "img/red-circle-table-5.3d87de53.png";